import { api } from './api';

export interface AuditLogRow {
  id: string;
  company_id: string;
  workspace_id: string | null;
  user_id: string | null;
  action: string;
  target_kind: string | null;
  target_id: string | null;
  payload: Record<string, unknown>;
  occurred_at: string;
}

export const auditLogApi = {
  async list(companyId: string, limit = 200): Promise<AuditLogRow[]> {
    const r = await api.get<AuditLogRow[]>(`/api/companies/${companyId}/audit-log`, { params: { limit } });
    return r.data;
  },
};
